<template>
    <div class="app-instatll-panel">
        <!-- 选择安装应用 -->
        <v-dialog
            :open="currentStep === 'init'"
            :title="!fromBind ? `请先在企业微信上安装企点应用「${appname}」` : '绑定企业微信账号和通讯录'"
            kind="default"
            :class="{
                'app-install-panel-picker': true,
                'app-install-panel-dialog': true,
                'app-install-panel-closeicon-visible': !fromBind
            }"
            @close="handleClose"
        >
            <v-card-picker v-model="isRegistered" :options="options" class="picker-card">
                <template slot-scope="props" slot="item">
                    <div class="picker-item">
                        <v-icon :name="props.item.icon"></v-icon>
                        <span>{{ props.item.text }}</span>
                    </div>
                </template>
            </v-card-picker>
            <div class="picker-footer">
                <v-button
                    v-if="isRegistered"
                    status="primary"
                    size="large"
                    registered-button-text
                    @click="currentStep = 'register-comfirm'"
                >
                    {{ registeredButtonText }}</v-button
                >
                <v-button v-else status="primary" size="large" @click="currentStep = 'install-comfirm'">{{
                    !fromBind ? setupButtonText : '开始绑定'
                }}</v-button>
            </div>
        </v-dialog>

        <!-- 已经注册没有安装应用 -->
        <v-dialog
            :open="currentStep === 'install-init'"
            :title="`请先在企业微信上安装企点应用「${appname}」`"
            kind="default"
            class="app-install-panel-picker app-install-panel-dialog app-install-panel-closeicon-visible"
            @close="handleClose"
        >
            <div class="info">
                <v-icon name="image"></v-icon>
                <p>
                    请使用已绑定的企业微信<span style="color: #ff8345;">{{ workweixinName }}</span
                    ><br />来扫码安装企点应用
                </p>
            </div>
            <div class="picker-footer">
                <v-button status="primary" size="large" @click="toInstallApp">去安装应用</v-button>
            </div>
        </v-dialog>

        <!-- 安装绑定前确认以下信息 -->
        <v-dialog
            :open="currentStep === 'install-comfirm'"
            title="开始安装前，请确认以下信息"
            kind="confirm"
            class="app-install-panel-dialog"
            @confirm="toInstallApp"
            @cancel="handleClose"
            @close="handleClose"
        >
            <div class="app-install-panel-dialog-desc">
                <ol v-if="!fromBind">
                    <li>请选择要关联企点业务的企业微信来安装应用，安装后，将<span>不可更改</span>企业微信</li>
                    <li>
                        为了保证企点应用在企业微信平台中能正常使用，请确保企业微信<span>已认证</span>主体<br />信息，且和企点主体信息相同
                        <ul>
                            <li>
                                如果还未认证，请用注册企点的主体信息<a
                                    a
                                    @click="externalJump('https://work.weixin.qq.com/wework_admin/auth_index')"
                                    >认证企业微信</a
                                >
                            </li>
                            <li>
                                如果主体信息不一致，请<a
                                    @click="externalJump('https://work.weixin.qq.com/wework_admin/auth_index')"
                                    >更换企业微信主体信息</a
                                >，或联系经销商更换<br />企点主体信息
                            </li>
                        </ul>
                    </li>
                    <li>在企业微信上安装企点应用时，请将相关员工添加到可见范围内</li>
                </ol>
                <ol v-else>
                    <li>请选择要关联企点业务的企业微信来绑定，绑定后，将<span>不可更改</span>企业微信</li>
                    <li>
                        为了保证企点能正常对接企业微信通讯录，请确保企业微信<span>已认证</span>主体信息，<br />且和企点主体信息相同
                        <ul>
                            <li>
                                如果还未认证，请用注册企点的主体信息<a
                                    a
                                    @click="externalJump('https://work.weixin.qq.com/wework_admin/auth_index')"
                                    >认证企业微信</a
                                >
                            </li>
                            <li>
                                如果主体信息不一致，请<a
                                    @click="externalJump('https://work.weixin.qq.com/wework_admin/auth_index')"
                                    >更换企业微信主体信息</a
                                >，或联系经销商更换<br />企点主体信息
                            </li>
                        </ul>
                    </li>
                </ol>
            </div>
            <span slot="confirm-text">{{ !fromBind ? '去安装应用' : '去绑定' }}</span>
        </v-dialog>

        <!-- 注册企业前确认以下信息 -->
        <v-dialog
            :open="currentStep === 'register-comfirm'"
            title="开始注册前，请确认以下信息"
            kind="confirm"
            class="app-install-panel-dialog"
            @confirm="toRegisterWorkWeixin"
            @cancel="handleClose"
            @close="handleClose"
        >
            <div class="app-install-panel-dialog-desc">
                <ol v-if="!fromBind">
                    <li>注册企业微信将自动安装企点应用</li>
                    <li>
                        为了保证企点应用在企业微信平台中能正常使用，请在注册<br />企业微信后，用注册企点的主体信息<span
                            @click="externalJump('https://work.weixin.qq.com/wework_admin/auth_index')"
                            >去认证企业微信</span
                        >（预计<br />5个工作日内可完成认证）
                    </li>
                </ol>
                <div v-else style="text-align:center;">
                    为了保证企点能正常对接企业微信通讯录，<br />请在注册企业微信后，用注册企点的主体信息<br /><span
                        @click="externalJump('https://work.weixin.qq.com/wework_admin/auth_index')"
                        >去认证企业微信</span
                    >（预计5个工作日内可完成认证）
                </div>
            </div>
            <span slot="confirm-text">去注册企业微信</span>
        </v-dialog>

        <!-- 跳转注册企业微信之后 -->
        <v-dialog
            :open="currentStep === 'register-result'"
            title="是否已注册好企业微信？"
            kind="confirm"
            class="app-install-panel-register-info app-install-panel-dialog"
            @confirm="comfirmRegisterRusult"
            @cancel="comfirmRegisterRusult"
            @close="handleClose"
        >
            <span slot="confirm-text">已注册</span>
            <span slot="cancel-text">以后再注册</span>
        </v-dialog>

        <!-- 注册后返回结果列表-测试用 -->
        <v-dialog v-model="stepVisible" title="注册验证结果列表" @close="handleClose">
            <p v-for="step of stepEnums" :key="step.value" style="padding:5px">
                <v-button status="primary" size="large" @click="currentStep = step.value">{{ step.text }}</v-button>
            </p>
        </v-dialog>

        <!-- 绑定成功-需要走绑定流程 -->
        <v-dialog
            :open="currentStep === 'install-success-and-bind'"
            kind="alert"
            :status="installSuccessStatus"
            class="app-install-panel-register-info app-install-panel-dialog"
            @close="handleClose"
        >
            <div slot="title" class="app-instatll-dialog-title">
                {{ installSuccessTitle }}
            </div>
            <div slot="footer" class="picker-footer">
                <v-button status="primary" size="large" @click="jumpContactPage">{{
                    fromBind ? '开始绑定企业微信通讯录' : '开始配置通讯录参数'
                }}</v-button>
            </div>
        </v-dialog>

        <!-- 跳转绑定后结果页面 -->
        <v-dialog
            :open="currentStep === 'bind-result'"
            title="是否已配置好通讯录参数？"
            kind="confirm"
            class="app-install-panel-register-info app-install-panel-dialog"
            @confirm="comfirmBindRusult"
            @cancel="comfirmBindRusult"
            @close="handleClose"
        >
            <span slot="confirm-text">已配置</span>
            <span slot="cancel-text">未配置，现在配置</span>
        </v-dialog>

        <!-- 安装成功-不需要走绑定流程 -->
        <v-dialog
            :open="currentStep === 'install-success'"
            :title="`成功安装「${appname}」应用`"
            kind="alert"
            status="success"
            class="app-install-panel-register-info app-install-panel-dialog"
            @close="handleClose"
        >
            <div slot="footer" class="picker-footer">
                <v-button status="primary" size="large" @click="currentStep = ''">开始使用</v-button>
            </div>
        </v-dialog>

        <!-- 安装失败-扫码的企业和绑定的企业不一致 -->
        <v-dialog
            :open="currentStep === 'install-fail-bind-error'"
            title="应用安装失败"
            kind="alert"
            status="warning"
            class="app-install-panel-register-info app-install-panel-dialog"
            @close="handleClose"
        >
            <div class="app-install-panel-dialog-desc app-install-panel-dialog-desc-center">
                请使用已绑定的企业微信<span> {{ workweixinName }} </span><br />来扫码安装应用
            </div>
            <div slot="footer" class="picker-footer">
                <v-button status="primary" size="large" @click="show">重试安装应用</v-button>
            </div>
        </v-dialog>

        <!-- 绑定失败-主体信息错乱 -->
        <v-dialog
            :open="currentStep === 'install-fail-confusion'"
            kind="alert"
            status="warning"
            class="app-install-panel-register-info app-install-panel-dialog"
            @confirm="onRefresh"
            @cancel="currentStep = 'init'"
            @close="handleClose"
        >
            <div slot="title" class="app-instatll-dialog-title">
                企业微信和企点主体信息不同，<span v-if="!fromBind"
                    >企业微信<br />绑定失败，请在更换主体信息后重新验证</span
                >
                <span v-else>绑定失败<br />请在更换主体信息后，重新验证</span>
            </div>
            <div class="app-install-panel-dialog-desc app-install-panel-dialog-desc-center">
                请<a @click="externalJump('https://work.weixin.qq.com/wework_admin/auth_index')">更换企业微信主体信息</a
                >，<br />或联系经销商更换企点主体信息
            </div>
            <div slot="footer" class="picker-footer">
                <v-button status="primary" size="large" @click="onRefresh">我已更换主体信息，重新验证</v-button> <br />
                <v-button class="register" status="default" size="large" @click="changeWework">
                    更换企业微信
                </v-button>
            </div>
        </v-dialog>

        <!-- 绑定失败-主体信息未验证 -->
        <v-dialog
            :open="currentStep === 'install-fail-unverified'"
            kind="alert"
            status="warning"
            class="app-install-panel-register-info app-install-panel-dialog"
            @close="handleClose"
        >
            <div slot="title" class="app-instatll-dialog-title">
                企业微信未认证主体信息，企业微信<br />绑定失败，请在认证主体信息后重新验证
            </div>
            <div class="app-install-panel-dialog-desc app-install-panel-dialog-desc-center">
                请使用注册企点的主体信息来<a @click="externalJump('https://work.weixin.qq.com/wework_admin/auth_index')"
                    >认证企业微信</a
                >
            </div>
            <div slot="footer" class="picker-footer">
                <v-button status="primary" size="large" @click="onRefresh">重新验证</v-button> <br />
                <v-button class="register" status="default" size="large" @click="changeWework">更换企业微信</v-button>
            </div>
        </v-dialog>

        <!-- 绑定失败-系统异常 -->
        <v-dialog
            :open="currentStep === 'install-fail-exception'"
            title="系统异常，请重试"
            kind="alert"
            class="app-install-panel-register-info app-install-panel-dialog"
            @close="handleClose"
        >
            <div slot="footer" class="picker-footer">
                <v-button status="primary" size="large" @click="onRefresh">重试</v-button>
            </div>
        </v-dialog>

        <!-- 绑定失败-未授权 -->
        <v-dialog
            :open="currentStep === 'install-fail-unauthorization'"
            :title="!fromBind ? '应用授权失败，请重新授权' : '授权失败，请重新授权'"
            kind="alert"
            status="warning"
            class="app-install-panel-register-info app-install-panel-dialog"
            @close="handleClose"
        >
            <div class="app-install-panel-dialog-desc app-install-panel-dialog-desc-center">
                重新授权前，请先在
                <a @click="externalJump('https://work.weixin.qq.com/wework_admin/frame#apps')"
                    >企业微信后台-<br />应用管理中心</a
                >删除「{{ appname }}」应用
            </div>
            <div slot="footer" class="picker-footer">
                <v-button status="primary" size="large" @click="show">重试授权</v-button>
            </div>
        </v-dialog>

        <!-- 绑定失败-超时 -->
        <v-dialog
            :open="currentStep === 'install-fail-overtime'"
            :title="!fromBind ? '应用授权失败，请重试' : '授权失败，请重试'"
            kind="alert"
            status="warning"
            class="app-install-panel-register-info app-install-panel-dialog"
            @close="handleClose"
        >
            <div slot="footer" class="picker-footer">
                <v-button status="primary" size="large" @click="onRefresh">重试</v-button>
            </div>
        </v-dialog>
    </div>
</template>

<script>
// 业务调用方会传进企业微信绑定状态、应用id、应用名字、跳转链接等信息
// 根据绑定状态和应用信息展示不同的安装弹框
// 到企业微信侧跳转回来要根据安装状态展示不同的安装结果弹框
import { Icon } from 'vhtml-ui';
import urlTool from '@/utils/urlTool';
import Gateway from '@/utils/Gateway';
import getBindInfo from '@/cgi/getBindInfo';
import getWeworkCorpInfo from '@/cgi/getWeworkCorpInfo';
import getInsteadAppResult from '@/cgi/getInsteadAppResult';
import isZhitui from '@/cgi/isZhitui';

const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    name: 'InstallAppPanel',
    components: {},
    props: {
        // 开启面板
        value: Boolean,

        // 存在绑定通讯录流程
        bindContact: Boolean,

        // 选择是否有企业微信
        // 是否是绑定流程 企业微信账号页入口调用弹框是绑定流程
        fromBind: {
            type: Boolean,
            default: false
        },

        // 安装应用id
        // appId: {
        //     type: String,
        //     default: ''
        // },

        // // 安装应用名称
        // appname: {
        //     type: String,
        //     default: 'XXX'
        // },

        // 企业微信帐号名称
        // workweixinName: {
        //     type: String,
        //     default: '这里是企业微信名称'
        // },

        // 安装/绑定面板按钮
        setupButtonText: {
            type: String,
            default: '开始安装应用'
        },

        // 开始注册
        registeredButtonText: {
            type: String,
            default: '开始注册企业微信'
        },

        // 业务标识
        businessId: {
            type: String,
            default: ''
        },

        // 自定义安装流程

        custInstall: {
            type: Boolean,
            default: false
        }

        // 推广二维码Id
        // templateId: {
        //     type: String,
        //     default: ''
        // }
    },
    data() {
        return {
            // 安装应用id
            appId: '',

            // 安装应用名称
            appname: '',

            options: [
                { icon: 'opened-work-weixin', value: 0, text: `我已有企业微信\n绑定企业微信账号` },
                { icon: 'unopened-work-weixin', value: 1, text: `还未注册企业微信\n现在注册` }
            ],
            isRegistered: 0,
            /**
             * 定义当前绑定阶段
             * -. int               初始化
             * -. install-init      待安装初始化
             * -. install-comfirm   安装确认
             * -. register-comfirm  注册确认
             * -. register-result   注册结果
             * -. install-success      安装成功
             * -. install-success-and-bind 安装成功-需要绑定通讯录
             * -. bind-result              绑定通讯录参数结果确认
             * -. bind-process             绑定通讯录参数
             * -. install-fail-bind-error  安装失败-扫码的企业和绑定的企业不一致
             * -. install-fail-confusion   安装失败-主体信息错乱
             * -. install-fail-unverified  安装失败-主体信息未验证
             * -. install-fail-exception   安装失败-系统异常
             * -. install-fail-unauthorization   安装失败-未授权
             * -. install-fail-overtime    安装失败-超时
             */
            currentStep: '',
            stepVisible: false,
            stepEnums: [
                { value: 'install-success', text: '安装成功' },
                { value: 'install-success-and-bind', text: '安装成功还需要绑定通讯录' },
                { value: 'install-fail-bind-error', text: '安装失败-绑定信息不正确' },
                { value: 'install-fail-confusion', text: '安装失败-主体信息错乱' },
                { value: 'install-fail-unverified', text: '安装失败-主体信息未验证' },
                { value: 'install-fail-exception', text: '安装失败-系统异常' },
                { value: 'install-fail-unauthorization', text: '安装失败-未授权' },
                { value: 'install-fail-overtime', text: '安装失败-超时' }
            ],

            // 应用安装链接
            appInstallUrl: '',

            // 企业微信帐号名称
            workweixinName: '',

            // 企业微信注册链接
            registerURL: '',

            // 选择是否有企业微信
            isBind: false,

            hasGetBindInfo: false,
            bindInfo: {},

            isCallBack: false
        };
    },

    computed: {
        installSuccessTitle() {
            const { appname } = this;
            let tit = '使用前请完成通讯录参数配置';

            // if (appname.length > 6) {
            //     appname = `${appname.slice(0, 6)}<br />${appname.slice(6)}`;
            // }

            if (this.fromBind) {
                tit = '恭喜您已成功绑定企业微信';
            } else if (this.isCallBack) {
                tit = `成功安装「${appname}」应用`;
            }

            return tit;
        },

        installSuccessStatus() {
            if (this.isCallBack) {
                return 'success';
            }

            return 'primary';
        },

        isParamsContact() {
            return isZhitui || (this.bindInfo && this.bindInfo.isParamsContact);
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.show();
            } else {
                this.currentStep = '';
            }
            // this.currentStep = val ? 'init' : '';
        },

        appId(val) {
            if (val) {
                this.getAppInstallUrl();
            }
        }

        // templateId(val) {
        //     if (val) {
        //         this.getRegisterURL();
        //     }
        // }
    },

    created() {
        // console.log(this.fromBind, 'fromBind');
    },
    methods: {
        // 手动关闭
        handleClose() {
            this.$emit('input', false);
            this.currentStep = '';
        },

        // 确认注册
        toInstallApp() {
            this.handleClose();

            if (this.appInstallUrl) {
                window.location.href = this.appInstallUrl;
            }

            // this.$message.success('这里要跳转到103-1');
            // this.stepVisible = true;
        },

        toRegisterWorkWeixin() {
            this.externalJump(this.registerURL);
            this.currentStep = 'register-result';
            // this.$message.success('这里要跳转到103-2');
        },

        // 确定注册结果
        comfirmRegisterRusult() {
            this.getAppInstallResult();
            // this.$message.success('这里要确定是否已经注册', () => {
            //     this.stepVisible = true;
            //     this.$message.warning('根据结果要这里要跳转到104');
            // });
        },

        // 确定绑定结果
        comfirmBindRusult(event) {
            this.getBindContact().then(isBind => {
                if (isBind) {
                    this.currentStep = '';
                } else {
                    this.jumpContactPage();
                }
            });
            event.preventDefault();
            // this.$message.success('这里要确定是否已经成功绑定', () => {
            //     this.stepVisible = false;
            //     this.$message.warning('如果没绑定，继续跳203');
            // });
        },

        // 弹窗也页面
        jumpNewPage(path) {
            const routeData = this.$router.resolve({ path });
            window.open(routeData.href, '_blank');
        },

        // 跳转到通讯录页面
        jumpContactPage() {
            if (this.fromBind) {
                // this.currentStep = 'bind-process';
                window.location.href = '/mng/weworkAccount/index/contact';
            } else {
                // this.jumpNewPage('/contact');
                this.externalJump('/mng/weworkAccount/index/contact');
                this.currentStep = 'bind-result';
            }
        },

        // 展示对应的弹框
        show() {
            if (this.custInstall) {
                this.custEmit('showInit');
            } else if (this.fromBind) {
                this.isBind = false;
                this.currentStep = 'init';
                this.getRegisterURL();
            } else {
                // 获取绑定状态和企业微信账号信息
                getBindInfo().then(res => {
                    const { isBind, bindInfo } = res || {};
                    this.isBind = isBind;
                    this.bindInfo = bindInfo;
                    this.hasGetBindInfo = true;

                    if (isBind) {
                        this.workweixinName = bindInfo && bindInfo.corp_full_name;
                        this.currentStep = 'install-init';
                    } else {
                        this.currentStep = 'init';
                        this.getRegisterURL();
                    }
                });
            }
        },

        showByStatus(appInfo, isCallBack) {
            const { suite_id: suiteId, name, status } = appInfo || {};

            this.appId = suiteId;
            this.appname = name;

            this.currentStep = '';
            this.isCallBack = isCallBack;

            if (status === 0) {
                this.show();
            } else if (isCallBack) {
                this.getAppInstallResult();
            } else {
                const statusComment = (appInfo.status_comment && JSON.parse(appInfo.status_comment)) || {};
                this.getAppInstallResult(statusComment);
            }
        },

        getIdByUrlParams() {
            const suiteId = urlTool.getUrlParameter('suite_id');
            const isInstallCallBack = urlTool.getUrlParameter('wwappinstall') === '1';

            return {
                suiteId,
                isInstallCallBack
            };
        },

        // 获取注册链接
        getRegisterURL() {
            if (this.businessId) {
                const reqData = {
                    business: this.businessId
                    // template: this.templateId
                };

                Gateway.get('/v1/corp/wework/RegisterURL', reqData)
                    .then(data => {
                        const { url } = data || {};
                        this.registerURL = url;
                    })
                    .catch(message => {
                        this.$message.error(message || '获取注册链接错误');
                    });
            }
        },

        // 获取应用安装链接
        getAppInstallUrl() {
            if (this.appId) {
                let jumpUrl = urlTool.removeURLParameter(window.location.href, 'suite_id');
                jumpUrl = urlTool.removeURLParameter(jumpUrl, 'wwappinstall');
                jumpUrl = urlTool.addUrlParameter(jumpUrl, 'suite_id', this.appId);

                const reqData = {
                    suite_id: this.appId,
                    jump: jumpUrl
                };

                Gateway.get('/v1/corp/wework/AppInstallUrl', reqData)
                    .then(data => {
                        const { url } = data || {};
                        this.appInstallUrl = url;
                    })
                    .catch(message => {
                        this.$message.error(message || '获取应用安装链接错误');
                    });
            }
        },

        // 获取安装应用结果
        getAppInstallResult(statusComment) {
            const installResultReq = this.installResultPromise(statusComment);

            installResultReq
                .then(resData => {
                    this.handleInstallResult(resData);
                    // this.handleInstallResult({status: 0});
                })
                .catch(message => {
                    this.$message.error(message || '获取应用安装结果错误');
                });
        },

        handleInstallResult(resData) {
            const { status, corp_name: corpName } = resData || {};
            const initStatus = parseInt(status, 10);
            switch (initStatus) {
                case 0:
                    if (this.bindContact) {
                        this.getBindContact().then(isBindContact => {
                            if (!isBindContact) {
                                this.currentStep = 'install-success-and-bind';
                            } else {
                                this.currentStep = 'install-success';
                            }
                        });
                    } else {
                        this.currentStep = 'install-success';
                    }
                    break;
                case 1:
                    this.currentStep = 'install-fail-exception';
                    break;
                case 2:
                    if (corpName) {
                        this.workweixinName = corpName;
                    }
                    this.currentStep = 'install-fail-bind-error';
                    break;
                case 3:
                    this.currentStep = 'install-fail-confusion';
                    break;
                case 4:
                    this.currentStep = 'install-fail-unverified';
                    break;
                case 5:
                    this.currentStep = 'install-fail-unauthorization';
                    break;
                default:
                    this.currentStep = '';
            }
        },

        // 外部跳转
        externalJump(path) {
            window.open(path, '_blank');
        },

        // 获取是否已经绑定通讯录
        getBindContact() {
            return new Promise(resolve => {
                if (this.fromBind) {
                    resolve(false);
                } else if (this.hasGetBindInfo) {
                    if (this.isParamsContact) {
                        getWeworkCorpInfo()
                            .then(res => {
                                const { corpSecret } = res;
                                let isBindContact = false;

                                if (corpSecret) {
                                    isBindContact = true;
                                }

                                resolve(isBindContact);

                                this.$emit('bindContactChange', isBindContact);
                            })
                            .catch(message => {
                                this.$message.error(message);
                            });
                    } else {
                        getInsteadAppResult()
                            .then(data => {
                                const { hasInstall } = data || {};
                                resolve(hasInstall);

                                this.$emit('bindContactChange', hasInstall);
                            })
                            .catch(message => {
                                this.$message.error(message);
                            });
                    }
                } else {
                    getBindInfo().then(res => {
                        const { isBind, bindInfo } = res || {};

                        this.isBind = isBind;
                        this.bindInfo = bindInfo;
                        this.hasGetBindInfo = true;

                        this.getBindContact();
                    });
                }
            });
        },

        // 刷新
        onRefresh() {
            // this.$router.go(0);
            // window.location.reload();

            if (this.custInstall) {
                this.custEmit('onRefresh');
            } else {
                this.getAppInstallResult();
            }
        },

        installResultPromise(statusComment) {
            return new Promise(resolve => {
                if (statusComment) {
                    resolve(statusComment);
                } else {
                    const reqData = {
                        suite_id: this.appId
                    };

                    Gateway.get('/v1/corp/wework/AppInstallResult', reqData).then(data => {
                        resolve(data);
                    });
                }
            });
        },

        changeWework() {
            if (this.custInstall) {
                this.custEmit('changeWework');
            } else {
                this.show();
            }
        },

        custEmit(e) {
            this.currentStep = '';
            this.$emit(e);
        }
    }
};
</script>

<style lang="less" scoped>
@import './style.less';
.app-install-panel-dialog-desc {
    ol {
        list-style-type: decimal;
        li {
            padding-left: 6px;
        }
    }
    ul {
        margin-left: 20px;
        list-style-type: disc;
        li {
            padding-left: 0;
        }
    }
}
</style>
